webpackJsonp([53338925692345],{

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function replaceArgs(msg, argList) {
	  var argIdx = 0;
	  return msg.replace(/%s/g, function () {
	    var arg = argList[argIdx++];
	    return arg === undefined ? '[missing argument]' : arg;
	  });
	}
	
	// When the message contains a URL (like https://fb.me/react-refs-must-have-owner),
	// make it a clickable link.
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	function urlify(str) {
	  var urlRegex = /(https:\/\/fb\.me\/[a-z\-]+)/g;
	
	  var segments = str.split(urlRegex);
	
	  return segments.map(function (message, i) {
	    if (i % 2 === 1) {
	      return Glamor.createElement(
	        'a',
	        { key: i, target: '_blank', rel: 'noopener', href: message },
	        message
	      );
	    }
	    return message;
	  });
	}
	
	// `?invariant=123&args[]=foo&args[]=bar`
	// or `// ?invariant=123&args[0]=foo&args[1]=bar`
	function parseQueryString(search) {
	  var rawQueryString = search.substring(1);
	  if (!rawQueryString) {
	    return null;
	  }
	
	  var code = '';
	  var args = [];
	
	  var queries = rawQueryString.split('&');
	  for (var i = 0; i < queries.length; i++) {
	    var query = decodeURIComponent(queries[i]);
	    if (query.indexOf('invariant=') === 0) {
	      code = query.slice(10);
	    } else if (query.indexOf('args[') === 0) {
	      args.push(query.slice(query.indexOf(']=') + 2));
	    }
	  }
	
	  return { args: args, code: code };
	}
	
	function ErrorResult(props) {
	  var code = props.code;
	  var errorMsg = props.msg;
	
	  if (!code) {
	    return Glamor.createElement(
	      'p',
	      null,
	      'When you encounter an error, you\'ll receive a link to this page for that specific error and we\'ll show you the full error text.'
	    );
	  }
	
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(
	      'p',
	      null,
	      Glamor.createElement(
	        'b',
	        null,
	        'The full text of the error you just encountered is:'
	      )
	    ),
	    Glamor.createElement(
	      'code',
	      null,
	      Glamor.createElement(
	        'b',
	        null,
	        urlify(errorMsg)
	      )
	    )
	  );
	}
	
	function ErrorDecoder(props) {
	  var code = null;
	  var msg = '';
	
	  var errorCodes = JSON.parse(props.errorCodesString);
	  var parseResult = parseQueryString(props.location.search);
	  if (parseResult != null) {
	    code = parseResult.code;
	    msg = replaceArgs(errorCodes[code], parseResult.args);
	  }
	
	  return Glamor.createElement(ErrorResult, { code: code, msg: msg });
	}
	
	exports.default = ErrorDecoder;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ErrorDecoder = __webpack_require__(145);
	
	var _ErrorDecoder2 = _interopRequireDefault(_ErrorDecoder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ErrorDecoder2.default; /**
	                                           * Copyright (c) 2013-present, Facebook, Inc.
	                                           *
	                                           * @emails react-core
	                                           */

	module.exports = exports['default'];

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ErrorDecoder = __webpack_require__(146);
	
	var _ErrorDecoder2 = _interopRequireDefault(_ErrorDecoder);
	
	var _Flex = __webpack_require__(15);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _hex2rgba = __webpack_require__(112);
	
	var _hex2rgba2 = _interopRequireDefault(_hex2rgba);
	
	var _MarkdownHeader = __webpack_require__(79);
	
	var _MarkdownHeader2 = _interopRequireDefault(_MarkdownHeader);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StickyResponsiveSidebar = __webpack_require__(80);
	
	var _StickyResponsiveSidebar2 = _interopRequireDefault(_StickyResponsiveSidebar);
	
	var _TitleAndMetaTags = __webpack_require__(18);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	var _theme = __webpack_require__(4);
	
	var _createLink = __webpack_require__(23);
	
	var _findSectionForPath = __webpack_require__(84);
	
	var _findSectionForPath2 = _interopRequireDefault(_findSectionForPath);
	
	var _sectionList = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	var ErrorPage = function ErrorPage(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  return Glamor.createElement(
	    _Flex2.default,
	    {
	      direction: 'column',
	      grow: '1',
	      shrink: '0',
	      halign: 'stretch',
	      css: {
	        width: '100%',
	        flex: '1 0 auto',
	        position: 'relative',
	        zIndex: 0
	      } },
	    Glamor.createElement(
	      _Container2.default,
	      null,
	      Glamor.createElement(
	        'div',
	        { css: _theme.sharedStyles.articleLayout.container },
	        Glamor.createElement(
	          _Flex2.default,
	          {
	            type: 'article',
	            direction: 'column',
	            grow: '1',
	            halign: 'stretch',
	            css: {
	              minHeight: 'calc(100vh - 40px)'
	            } },
	          Glamor.createElement(_MarkdownHeader2.default, {
	            path: data.markdownRemark.fields.path,
	            title: data.markdownRemark.frontmatter.title
	          }),
	          Glamor.createElement(_TitleAndMetaTags2.default, {
	            title: 'React - ' + data.markdownRemark.frontmatter.title
	          }),
	          Glamor.createElement(
	            'div',
	            { css: _theme.sharedStyles.articleLayout.content },
	            Glamor.createElement('div', {
	              css: _theme.sharedStyles.markdown,
	              dangerouslySetInnerHTML: { __html: data.markdownRemark.html }
	            }),
	            Glamor.createElement(
	              'div',
	              {
	                css: [_theme.sharedStyles.markdown, {
	                  marginTop: 30,
	                  '& code': {
	                    display: 'block',
	                    marginTop: 30,
	                    padding: '1rem',
	                    borderRadius: '0.5rem',
	                    backgroundColor: (0, _hex2rgba2.default)(_theme.colors.error, 0.1),
	                    color: _theme.colors.error
	                  }
	                }] },
	              Glamor.createElement(_ErrorDecoder2.default, {
	                errorCodesString: data.errorCodesJson.internal.contentDigest,
	                location: location
	              })
	            )
	          )
	        ),
	        Glamor.createElement(
	          'div',
	          { css: _theme.sharedStyles.articleLayout.sidebar },
	          Glamor.createElement(_StickyResponsiveSidebar2.default, {
	            createLink: _createLink.createLinkDocs,
	            defaultActiveSection: (0, _findSectionForPath2.default)(location.pathname, _sectionList.sectionListDocs),
	            location: location,
	            sectionList: _sectionList.sectionListDocs,
	            title: data.markdownRemark.frontmatter.title
	          })
	        )
	      )
	    )
	  );
	};
	
	// eslint-disable-next-line no-undef
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = ErrorPage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-error-decoder-html-js-b633e8df8fc02d049b2a.js